import classNames from 'classnames';
import FancyBorder from '../fancyBorder/FancyBorder';
import './modal.sass';

interface ModalComponent {
  visible?: boolean;
  children?: React.ReactNode;
  toggle?: any;
  additionalClass?: string;
  style?: Record<string, any>;
  hasExit?: boolean;
  hideCorners?: boolean;
}

export default function Modal({ children, toggle, additionalClass, style, hasExit = true, hideCorners = false }: ModalComponent) {
  return (
    <>
      <div className="modal">
        <div className="centered">
          {hideCorners ? (
            <>{children}</>
          ) : (
            <FancyBorder style={style} className={classNames(additionalClass, 'frame')}>
              {children}
            </FancyBorder>
          )}
        </div>
      </div>
      {hasExit && (
        <div className="modal__close" onClick={toggle}>
          <img src="https://prod.cdni.callofduty.com/prelogin/media/icon_close.svg" alt="Close" />
        </div>
      )}
      <div className="modal-mask" onClick={toggle} />
    </>
  );
}
